import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const GallerySection = () => {
  const galleryImages = [
    {
      id: 1,
      src: '/assets/images/468207487_17926837874985883_2793133492619956815_n-1767721988793.jpg',
      alt: 'Birria tacos being dipped in rich consommé broth'
    },
    {
      id: 2,
      src: '/assets/images/468234381_17926837667985883_5192488095589453560_n-1767722098625.jpg',
      alt: 'Cocktail with pink neon Quiero Más Tequila sign in background'
    },
    {
      id: 3,
      src: '/assets/images/468305673_17926837805985883_8912526632695545196_n-1767722147212.jpg',
      alt: 'Ramen noodle dish with colorful papel picado decorations'
    },
    {
      id: 4,
      src: '/assets/images/468355336_17926836530985883_6248633414569850848_n-1767722645115.jpg',
      alt: 'Mexican food spread featuring tacos, burritos, omelet with black beans and rice'
    },
    {
      id: 5,
      src: '/assets/images/468358776_17926837910985883_1449650272320193330_n-1767722776645.jpg',
      alt: 'Outdoor patio dining with birria tacos, consommé and colorful tiki cocktails'
    },
    {
      id: 6,
      src: '/assets/images/468396164_17926838612985883_6473680900042250756_n-1767722930229.jpg',
      alt: 'Taco salad in crispy tortilla bowl with colorful papel picado decorations'
    },
    {
      id: 7,
      src: '/assets/images/468396459_17926836737985883_5076252589505978310_n-1767723111624.jpg',
      alt: 'Layered dessert cake with fresh strawberries and churros with ice cream'
    },
    {
      id: 8,
      src: '/assets/images/469913837_122226934604010286_8452976807677288883_n-1767723159780.jpg',
      alt: 'Steak fajita platter with grilled steak strips, rice, beans, peppers, onions, corn and fresh salad'
    },
    {
      id: 9,
      src: '/assets/images/470059956_122226953678010286_1180735859884547509_n-1767723219722.jpg',
      alt: 'Cocktail photo featuring Kahlovera branded coconut cup, red tiki drink, and turquoise pineapple glass under Más Tequila neon sign'
    },
    {
      id: 10,
      src: '/assets/images/470634632_122228304902010286_7871360944950447504_n-1767723462484.jpg',
      alt: 'Loaded nachos platter with black beans, pickled onions, radish slices, melted cheese and fresh toppings'
    },
    {
      id: 11,
      src: '/assets/images/470638997_122228331722010286_8763762889174243804_n-1767723538151.jpg',
      alt: 'Burger with colorful paper flowers and french fries'
    },
    {
      id: 12,
      src: '/assets/images/468235527_17926846625985883_7485989141438227676_n-1767723623915.jpg',
      alt: 'Sizzling fajita platter with chicken, steak, shrimp, peppers, onions and margarita'
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, scale: 0.8 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5
      }
    }
  };

  return (
    <section className="py-16 bg-muted/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center mb-12"
        >
          <div className="inline-flex items-center space-x-2 bg-accent/10 px-4 py-2 rounded-full mb-4">
            <Icon name="Camera" size={20} className="text-accent" />
            <span className="text-accent font-body font-medium">GALLERY</span>
          </div>

          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-bold text-foreground mb-4">
            See What's <span className="text-primary">Happening</span>
          </h2>

          <p className="text-lg text-muted-foreground font-body max-w-2xl mx-auto">
            A glimpse into the Kahlovera experience - from our dishes to our atmosphere
          </p>
        </motion.div>

        {/* Gallery Grid - 4x6 */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4"
        >
          {galleryImages?.map((image) => (
            <motion.div
              key={image?.id}
              variants={itemVariants}
              whileHover={{ scale: 1.05, zIndex: 10 }}
              className="relative aspect-square rounded-lg overflow-hidden shadow-warm hover:shadow-warm-xl transition-all duration-300 cursor-pointer group"
            >
              <Image
                src={image?.src}
                alt={image?.alt}
                className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default GallerySection;